import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import { mojazReport } from "@/utils/dataLayerEvents";
import stl from "./MojazSection.module.css";
import { useTranslation } from "@i18n";
import { usePostDetails } from "@/common/Contexts/PostDetailsContext";
var MojazSection = function MojazSection(_ref) {
  var data = _ref.data,
    screen_view_referral = _ref.screen_view_referral;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _usePostDetails = usePostDetails(),
    helpers = _usePostDetails.helpers;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.wrapper,
    id: "mojaz-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.row, " ").concat(stl.head),
    id: "mojaz-header"
  }, /*#__PURE__*/React.createElement("strong", null, t("brief_mojaz_report", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/mojaz-logo.svg",
    alt: "Mojaz report icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.row, " ").concat(stl.body),
    id: "mojaz-body"
  }, (data === null || data === void 0 ? void 0 : data.total_owners) && /*#__PURE__*/React.createElement("div", {
    className: stl.section,
    id: "mojaz-owners"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/mojaz-icon-1.svg",
    alt: "Number of owners icon"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, t("number_owners", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("strong", null, data === null || data === void 0 ? void 0 : data.total_owners))), (data === null || data === void 0 ? void 0 : data.last_odometer_reading) && /*#__PURE__*/React.createElement("div", {
    className: stl.section,
    id: "mojaz-odometer"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/mojaz-icon-2.svg",
    alt: "Odometer reading icon"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, t("odometer_reading", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("strong", null, data === null || data === void 0 ? void 0 : data.last_odometer_reading, " ", /*#__PURE__*/React.createElement("span", null, t("km", {
    ns: "web_post_view"
  })), " ")))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.row, " ").concat(stl.footer),
    id: "mojaz-footer"
  }, /*#__PURE__*/React.createElement("a", {
    rel: "noopener noreferrer",
    target: "_blank",
    href: data === null || data === void 0 ? void 0 : data.full_report_url,
    id: "mojaz-full-report-link",
    onClick: function onClick() {
      return mojazReport("mojaz_report", screen_view_referral, helpers.getG4_data());
    }
  }, t("view_mojaz_full_report", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/red-arrow-left.svg",
    alt: "Arrow left icon"
  })));
};
export default MojazSection;